import axios, {AxiosError, AxiosRequestConfig} from 'axios';

import i18n from 'i18next';
import {LOCAL_STORAGE_CALC_STAND_KEY} from '../common/api/constants';
import {ROUTES} from 'routes/frov/constants';

export const calcStand =
  window.localStorage.getItem(LOCAL_STORAGE_CALC_STAND_KEY) || `${import.meta.env.VITE_APP_API}/calc-api`;

export const AXIOS_INSTANCE2 = axios.create({timeout: 300000, baseURL: calcStand});

export const customInstance2 = <T>(config: AxiosRequestConfig): Promise<T> => {
  const lang = i18n.language === 'ru' ? 'ru-RU' : 'en';
  const source = axios.CancelToken.source();

  return AXIOS_INSTANCE2({
    ...config,
    headers: {
      'Accept-Language': lang,
    },
    cancelToken: source.token,
  }).then(response => {
    if (response.status >= 400) {
      if (response.status === 404) {
        window.location.pathname = ROUTES.ERROR;
      }
      throw new Error(JSON.stringify(response.data));
    } else {
      return response.data;
    }
  });
};
export default customInstance2;
export type ErrorType<Error> = AxiosError<Error>;
